module.exports = __webpack_public_path__ + "static/img/bottom1.ca219948.png";